import { createReducer } from 'redux-create-reducer'
import { uiElements } from './uiElements_deprecated'
const initialState = {
  // copied on 2023-07-13 from https://sandbox.disco.ac/api/uielement/
  // TODO: delete unused ones
  // TODO: move all of them to code and delete this file
  // https://disco-team.atlassian.net/browse/TECHOPS-105
  elements: uiElements.results,
}
export type State = typeof initialState
export const uiElementsReducer = createReducer<State, any>(initialState, {})
